import {alphas, greysDark} from '../../styles/colorStyles';

export const lightButtonSemanticStyles = {
  chevronShadow: alphas.black30,
  border: alphas.black30,
};

export type ButtonSemanticStyles = typeof lightButtonSemanticStyles;

export const darkButtonSemanticStyles: ButtonSemanticStyles = {
  chevronShadow: alphas.black30,
  border: greysDark.shade40,
};
